import React, { useReducer } from "react";

const UserPledgesListContext = React.createContext();

const initialState = {
  fetchPledgesStatus: null,
  pledges: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setFetchPledgesStatus": {
      return {
        ...state,
        fetchPledgesStatus: action.payload,
      };
    }

    case "setPledges": {
      return {
        ...state,
        pledges: action.payload,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

function UserPledgesListProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UserPledgesListContext.Provider value={{ state, dispatch }}>
      {children}
    </UserPledgesListContext.Provider>
  );
}

function useUserPledgesList() {
  const context = React.useContext(UserPledgesListContext);
  if (context === undefined) {
    throw new Error(
      `useUserPledgesList must be used within a UserPledgesListProvider`
    );
  }
  return context;
}

export { UserPledgesListContext, UserPledgesListProvider, useUserPledgesList };
